import React, { useState, useEffect, useRef } from 'react';
import CustomChip from './CustomChip';

const AnimatedChip = ({ icon, text, onAction, style = {} }) => {
  const [expanded, setExpanded] = useState(false);
  const timerRef = useRef(null);
  const textRef = useRef(null);
  const [chipWidth, setChipWidth] = useState(30); // Initial collapsed width

  useEffect(() => {
    if (expanded && textRef.current) {
      const textWidth = textRef.current.offsetWidth;
      // Calculate width by adding extra space for the icon and padding
      const calculatedWidth = textWidth + 50; 
      setChipWidth(calculatedWidth);
    } else {
      setChipWidth(30); // collapsed width
    }
  }, [expanded, text]);

  const handleClick = (e) => {
    e.stopPropagation();
    if (!expanded) {
      setExpanded(true);
      timerRef.current = setTimeout(() => setExpanded(false), 1000);
    } else {
      clearTimeout(timerRef.current);
      if (onAction) onAction(e);
      setExpanded(false);
    }
  };

  useEffect(() => {
    return () => clearTimeout(timerRef.current);
  }, []);

  const chipStyle = {
    width: `${chipWidth}px`,
    transition: 'width 0.3s ease, border-radius 0.3s ease',
    borderRadius: expanded ? '20px' : '50%',
    justifyContent: expanded ? 'flex-start' : 'center',
    paddingLeft: expanded ? '12px' : '0px',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  };

  return (
    <CustomChip
      icon={icon}
      label={expanded ? (<span ref={textRef}>{text}</span>) : ''}
      onClick={handleClick}
      style={{ ...chipStyle, ...style }}
    />
  );
};

export default AnimatedChip;
